import { CommonModule } from "@angular/common";
import { NgModule } from "@angular/core";
import { DynamicTemplateDirective } from "./dynamic-template.directive";

@NgModule({
  imports: [CommonModule],
  declarations: [DynamicTemplateDirective],
  exports: [DynamicTemplateDirective]
})
export class DynamicTemplateModule {}
